export const GET_GPS_DEVICE_REQUEST = 'GET_GPS_DEVICE_REQUEST';
export const GET_GPS_DEVICE_SUCCESS = 'GET_GPS_DEVICE_SUCCESS';
export const GET_GPS_DEVICE_FAILURE = 'GET_GPS_DEVICE_FAILURE';

export const SET_GPS_DEVICE = 'SET_GPS_DEVICE';

export const getGpsDeviceRequest = (filters = {}) => ({
    type: GET_GPS_DEVICE_REQUEST,
    payload: {
        filters
    }
});

export const getGpsDeviceSuccess = (gps_device) => ({
    type: GET_GPS_DEVICE_SUCCESS,
    payload: {
        gps_device
    }
});

export const getGpsDeviceFailure = err => ({
    type: GET_GPS_DEVICE_FAILURE,
    error: err
});

export const setGpsDevice = (gps_device = {}) => ({
    type: SET_GPS_DEVICE,
    payload: {
        gps_device
    }
});
